module.exports = __webpack_public_path__ + "step2_044b.png";